export default [
  {
    path: '/minha-loja',
    name: 'app-minha-loja',
    component: () => import('@/views/apps/minha-loja/MinhaLoja.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Minha Loja',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        { text: 'Minha Loja', active: true },
      ],
    },
  },
  {
    path: '/minha-loja/banners',
    name: 'app-minha-loja-banners',
    component: () => import('@/views/apps/minha-loja/MinhaLojaBanners.vue'),
    meta: {
      requiresAuth: true,
      requiresWhiteLabel: true,
      pageTitle: 'Banners da Loja',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        { text: 'Minha Loja', to: '/minha-loja' },
        { text: 'Banners', active: true },
      ],
    },
  },
  {
    path: '/minha-loja/categorias',
    name: 'app-minha-loja-categorias',
    component: () => import('@/views/apps/minha-loja/MinhaLojaCategorias.vue'),
    meta: {
      requiresAuth: true,
      requiresWhiteLabel: true,
      pageTitle: 'Categorias da Loja',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        { text: 'Minha Loja', to: '/minha-loja' },
        { text: 'Categorias', active: true },
      ],
    },
  },
]
